var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"value":_vm.dateFormatted,"validate-on-blur":"","outlined":_vm.outlined},on:{"blur":_vm.emitInput}},'v-text-field',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }